import { Text } from '@makemydeal/dr-ui-bricks-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import styled, { css } from 'styled-components';

const LOGO_HEIGHT = '44px';
const LOGO_MAX_WIDTH = '180px';
const LOGO_MAX_WIDTH_PHONE = '120px';

export const HeaderContainer = styled.header`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 0 16px;
        color: ${theme.uiBricks.labelFontColor || '#000000'};
        background: ${theme.uiBricks.modalBackgroundColor || '#ffffff'};
        transition: all 0.2s cubic-bezier(0.1, 0.74, 0.28, 0.96);
        height: 61px;
    `}
`;

export const DealershipLogo = styled.div`
    margin-right: 20px;
    display: flex;
    align-items: center;
`;

export const StyledImage = styled.img`
    display: block;
    height: ${LOGO_HEIGHT};
    max-width: ${LOGO_MAX_WIDTH};
    object-fit: contain;
    object-position: left center;
    margin: 0;
    cursor: pointer;

    @media (max-width: ${BreakPoints.PHONE}) {
        max-width: ${LOGO_MAX_WIDTH_PHONE};
    }
`;

export const FallbackLockup = styled.div`
    display: flex;
    align-items: center;
    height: ${LOGO_HEIGHT};
    max-width: ${LOGO_MAX_WIDTH};
    cursor: pointer;

    @media (max-width: ${BreakPoints.PHONE}) {
        max-width: ${LOGO_MAX_WIDTH_PHONE};
    }
`;

export const DealerName = styled(Text)`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    overflow-wrap: anywhere;
    margin: 0;
    color: ${({ theme }) => theme.uiBricks.labelFontColor || '#000000'};
`;
